import styled, { css } from 'styled-components';
import { srOnly } from '@widgets/shared/styles/misc';
export const Label = styled.label `
  display: flex;
  flex-direction: column;
  cursor: pointer;
  width: 8rem;
  height: 6rem;
  padding: 1rem 1.6rem;
  align-items: center;
  justify-content: center;
  user-select: none;
  background-color: white;
  box-shadow: inset 0 0 0 0.4rem white;
  border: 0.1rem solid var(--border);
  border-radius: var(--border-radius-sm);
  ${({ theme: { sessionCheckbox } }) => sessionCheckbox}
`;
export const Input = styled.input `
  ${srOnly}

  ${(props) => {
    if (props.isDisabled) {
        return css `
        & + ${Label} {
          background-color: #f6f6f9;
          border: 0.1rem solid #f6f6f9;
          box-shadow: none;

          & > span {
            color: #cdd2de !important;
            z-index: 2;
          }
        }
      `;
    }
    return css ``;
}}

  &:checked + ${Label}{
    ${({ theme: { sessionCheckboxBefore } }) => sessionCheckboxBefore}
  }
`;
export const Time = styled.span `
  display: block;
  text-align: center;

  ${({ theme: { sessionTime } }) => sessionTime}
`;
export const Price = styled.span `
  //margin-top: 0.4rem;
  text-align: center;
  ${({ theme: { sessionPrice } }) => sessionPrice}
`;
export const Element = styled.div `
  //background-color: white;
  
  
  ${Input}{
    
  }
  
  & + & {
    margin-left: 2rem;
  }
`;
export const Availability = styled.span `
  display: block;
  text-align: left;
  display: flex;
  gap: 0.6rem;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  font-size: 1.2rem;
  line-height: 1;
  font-weight: normal;
  &::before {
    content: '';
    flex-shrink: 0;
    display: block;
    width: 0.8rem;
    height: 0.8rem;
    border: 0;
    border-radius: 0.8rem;
  }
  ${({ availability }) => {
    switch (availability) {
        case 'high':
            return css `
          &::before {
            background-color: var(--high-availability);
          }
        `;
        case 'average':
            return css `
          &::before {
            background-color: var(--average-availability);
          }
        `;
        case 'low':
            return css `
          &::before {
            background-color: var(--low-availability);
          }
        `;
        default:
            return css ``;
    }
}}

  ${({ theme: { sessionAvailability } }) => sessionAvailability}
`;
export default {
    Element,
    Input,
    Time,
    Price,
    Label,
    Availability,
};
